import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'

const PageLayout  = Loadable({ loader: () => import('layers/voting/containers/PageLayout/PageLayout'), loading })
const AuthLayout  = Loadable({ loader: () => import('layers/voting/containers/AuthLayout/AuthLayout'), loading })
const AdminLayout = Loadable({ loader: () => import('layers/voting/containers/AdminLayout/AdminLayout'), loading })

const HomePage    = Loadable({ loader: () => import('layers/voting/pages/HomePage/HomePage'), loading })
const ProjectPage = Loadable({ loader: () => import('layers/voting/pages/ProjectPage/ProjectPage'), loading })
const AdminPage   = Loadable({ loader: () => import('layers/voting/pages/AdminPage/AdminPage'), loading })


export default (links) => (
  <Route>
    <Route component={PageLayout}>
      <Route component={AuthLayout}>
        <Route path={links.root} component={HomePage} />
        <Route path={links.project} component={ProjectPage} />

        <Route component={AdminLayout}>
          <Route path={links.admin.root} component={AdminPage} />
          <Route path={links.admin.add} component={AdminPage} />
          <Route path={links.admin.edit} component={AdminPage} />

          <Redirect path={`${links.admin.root}/*`} to={links.admin.root} />
        </Route>
      </Route>

      <Redirect path={`${links.root}/*`} to={links.root} />
    </Route>
  </Route>
)
